"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPdfElementsOutputDtoSchema = exports.getPdfElementsInputDtoSchema = exports.pdfElementWithMetadataSchema = exports.pdfElementTagSetSchema = void 0;
const z = __importStar(require("zod"));
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
exports.pdfElementTagSetSchema = z.object({
    propertyTags: z.array(z.string()),
    packageTags: z.array(z.string()),
});
exports.pdfElementWithMetadataSchema = sigma_engine_shared_1.PdfElementSchema.extend({
    index: z.number(),
    description: sigma_engine_shared_1.PdfElementDescriptionSchema.optional(),
    tags: exports.pdfElementTagSetSchema.optional(),
});
exports.getPdfElementsInputDtoSchema = z.object({
    fileId: z.string(),
    pageNumbers: z
        .array(z.number().int().positive())
        .min(1)
        .max(10)
        .refine((pageNumbers) => new Set(pageNumbers).size === pageNumbers.length, {
        message: 'pageNumbers must be unique',
    })
        .optional()
        .describe('One-based page numbers to include (1-10).'),
    elementTypes: z
        .array(sigma_engine_shared_1.PdfElementTypeSchema)
        .min(1)
        .optional()
        .describe('Element types to include, e.g. ["table"] for tables only.'),
    elementIndexes: z
        .array(z.number().int().min(0))
        .min(1)
        .max(50)
        .refine((indexes) => new Set(indexes).size === indexes.length, {
        message: 'elementIndexes must be unique',
    })
        .optional()
        .describe('Document-wide element indexes to include (1-50), e.g. from a locate tool.'),
    tableFormat: sigma_engine_shared_1.PdfTableFormatSchema.optional().describe('How table cells are serialized into text: "json" (default; raw cell rows with row/column spans) or ' +
        '"markdown" (compact, far fewer tokens, but merged cells appear only in their top-left position).'),
});
exports.getPdfElementsOutputDtoSchema = z.object({
    fileId: z.string(),
    elements: z.array(exports.pdfElementWithMetadataSchema),
});
//# sourceMappingURL=get-pdf-elements.dto.js.map